module.exports = __webpack_public_path__ + "assets/5ffd1a98ab2095f33860037eb5f40292.png";